import { apiSlice } from "./apiSlice";

export const popUpApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPopUp: builder.mutation({
      query: (popUpData) => ({
        url: "/popUps/createPopUp",
        method: "POST",
        body: popUpData,
      }),
      invalidatesTags: ["PopUp"],
    }),

    deletePopUp: builder.mutation({
      query: (id) => ({
        url: `/popUps/deletePopUp/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PopUp"],
    }),

    updatePopUp: builder.mutation({
      query: ({ popUpData, id }) => ({
        url: `/popUps/updatePopUp/${id}`,
        method: "PATCH",
        body: popUpData,
      }),
      invalidatesTags: ["PopUp"],
    }),

    getAllPopUp: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/popUps/getAllPopUp?${params.toString()}`,
          method: "GET",
        };
      },

      providesTags: ["PopUp"],
    }),
    getPopUpById: builder.query({
      query: (id) => ({
        url: `/popUps/getPopUpById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreatePopUpMutation,
  useDeletePopUpMutation,
  useGetAllPopUpQuery,
  useGetPopUpByIdQuery,
  useUpdatePopUpMutation,
} = popUpApi;
